export const lastClickTime =
  typeof window !== 'undefined' && window.localStorage
    ? window.localStorage.getItem('lastSurveyStartButtonClick')
    : null;
